import Keycloak from 'keycloak-js';

// Session-scoped only (not localStorage): cleared on logout and when the
// tab/browser closes, so a stale company can't linger indefinitely. Kept
// across page reloads within a session so the Keycloak login redirect
// (which does a full page navigation away and back) can complete.
export const COMPANY_STORAGE_KEY = 'bictorys_company';

let _instance: Keycloak | null = null;

function buildKeycloakUrl(company: string): string {
  const isDev = import.meta.env.VITE_APP_ENV === 'development';
  return isDev
    ? `https://auth.dev.${company}.com`
    : `https://auth.${company}.com`;
}

export function initKeycloak(company: string): Keycloak {
  _instance = new Keycloak({
    url: buildKeycloakUrl(company),
    realm: company,
    clientId: 'partenaire',
  });
  return _instance;
}

// Proxy forwards all property accesses to the live instance at call time.
// http.ts imports this default export and reads .token / calls .updateToken()
// only during actual API requests — never at import time — so this is safe.
const keycloakProxy = new Proxy({} as Keycloak, {
  get(_, prop) {
    if (!_instance) {
      if (prop === 'then') return undefined; // prevent accidental Promise detection
      throw new Error(`Keycloak.${String(prop)} accessed before initKeycloak()`);
    }
    const val = Reflect.get(_instance, prop);
    return typeof val === 'function' ? (val as (...args: unknown[]) => unknown).bind(_instance) : val;
  },
});

export default keycloakProxy;
